import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Routes } from '@share/constants';
import { FunctionalRootState, isDisplayAccountHub } from '@share/utils';

import { Dashboard } from '../dashboard';
import { isAccountTravelAgent } from './utils';

/**
 * `/:accountUsername/dashboard`: travel agents on hub-enabled tenants land on the hub's Overview
 * (commissions card, next client trip), with My reports and the other agent tools in the rail. Everyone else, including Capital Vacations, keeps the
 * legacy dashboard unchanged.
 */
export const AccountHubDashboardGate = (): React.ReactElement => {
  const { accountUsername } = useParams<{ accountUsername: string }>();
  const account = useSelector((state: FunctionalRootState) => state.loginStore.account);
  const items = useSelector((state: FunctionalRootState) => state.navigationMenuStore.items);

  if (isDisplayAccountHub(account) && isAccountTravelAgent(account, items)) {
    return <Redirect to={`/${encodeURIComponent(accountUsername)}${Routes.RsiAccount}`} />;
  }

  return <Dashboard />;
};
